import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-asm',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './asm.component.html',
  styleUrl: './asm.component.scss'
})
export class AsmComponent {

}
